export const COLUMNS = [
	{
		accessorKey: 'description',
	},
	{
		accessorKey: 'value',
	},
]
